var _rect, _path, _g, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembershipRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 20,
    viewBox: "0 0 53 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 51,
    height: 17,
    fill: "#155A9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C21.3735 2.99599 32.3703 3.19935 50.5 0L52.5 16.5138C39.3172 19.8165 22.2026 19.8165 0 20V3Z",
    fill: "url(#paint0_linear_230_3118)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_3118)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M9 13.0375L6.15533 9.97781C5.68286 9.46962 4.875 9.82954 4.875 10.5482L5.21875 15.9274L9 13.0375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9 13.0375L11.8447 9.97781C12.3171 9.46962 13.125 9.82954 13.125 10.5482L12.7812 15.9274L9 13.0375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36683 8.48649C8.60354 7.92699 9.39645 7.92699 9.63316 8.48649L12.7812 15.9274H5.21875L8.36683 8.48649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 13.125,
    cy: 8.70866,
    r: 0.859375,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 6.81804,
    r: 0.859375,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 4.875,
    cy: 8.70866,
    r: 0.859375,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2311 13.6108L39.6041 14.6061L39.0714 10.5241L40.8117 10.297L40.9042 11.0059L45.0507 10.4649L44.9582 9.75586L46.6984 9.52877L47.2311 13.6108ZM43.7737 9.38602L42.1946 9.59209L41.1763 7.39791L40.925 6.89537L40.8176 7.41194L40.0826 9.90047L38.1597 10.1514L39.661 5.24673L41.702 4.98039L43.7737 9.38602ZM46.6522 9.17427L44.9119 9.40137L44.2881 4.62106L46.0284 4.39397L46.6522 9.17427ZM45.3114 12.4629L45.2301 11.8399L41.0836 12.381L41.1649 13.004L45.3114 12.4629Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2009 15.5933L28.3965 6.39844L30.1998 6.24067L30.5056 9.73604L32.1754 9.58995L31.8706 6.10571L33.6739 5.94794L33.9719 9.35426L35.2855 9.23934L34.9865 5.82189L36.7898 5.66411L37.604 14.9703L35.8007 15.128L35.4335 10.9314L34.12 11.0463L34.4774 15.1316L29.2009 15.5933ZM30.8699 13.8993L32.5396 13.7532L32.3098 11.1261L30.64 11.2722L30.8699 13.8993Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2526 15.8896H19.2359V11.9788H27.2526V15.8896ZM18.7051 8.4038V6.60547H22.9301V8.08963H23.5151V6.60547H25.1617V11.5996H23.5151V9.5413H22.9301V11.4155H18.7051V9.61713V8.4038ZM27.2526 11.5996H25.6059V6.60547H27.2526V11.5996ZM20.9909 13.4738V14.3946H25.4976V13.4738H20.9909ZM21.2834 9.92047V8.10047H20.3517V9.92047H21.2834Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_230_3118",
    x1: -1.23517e-8,
    y1: 10.75,
    x2: 51.75,
    y2: 10.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1890FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1573CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1890FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_3118"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 5.5,
    width: 11,
    height: 11,
    rx: 0.55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipRibbon);
export default __webpack_public_path__ + "static/media/membership-ribbon.5c80c45f80c7fb7df6dc4f15ec4fc93f.svg";
export { ForwardRef as ReactComponent };